export enum CSSClassnames {
  OPENED = "faq-collapse-opened",
}
